import React from "react";
import ConstructionIcon from "@mui/icons-material/Construction";
import { COBRECDetail } from "./Components/COBRECDetail";
import AgricultureIcon from "@mui/icons-material/Agriculture";

export const ChartRecuperacion2 = ({ data, ejercicio, periodo, sucursales }) => {
  return (
    <table
      className="chart-recuperacion-table_complete"
      cellPadding={0}
      cellSpacing={0}
    >
      <tbody>
        <COBRECDetail
          item={data.filter((item) => item.tipo_cartera === "Operación")}
          filtrado={"O"}
          icono={
            <div>
              <AgricultureIcon /> Operación
            </div>
          }
          graphics={true}
          permisos={sucursales}
        />
        <COBRECDetail
          item={data.filter((item) => item.tipo_cartera === "Revolvente")}
          filtrado={"R"}
          icono={
            <div>
              <ConstructionIcon /> Revolvente
            </div>
          }
          graphics={true}
          permisos={sucursales}
        />
        <COBRECDetail
          item={data.filter((item) => item.tipo_cartera === "Especial")}
          filtrado={"E"}
          icono={
            <div>
              <ConstructionIcon /> Especial
            </div>
          }
          permisos={sucursales}
        />
        <COBRECDetail
          item={data.filter((item) => item.tipo_cartera === "Juridica")}
          filtrado={"M"}
          icono={
            <div>
              <ConstructionIcon /> Mora + 180 dias
            </div>
          }
          permisos={sucursales}
        />
        <COBRECDetail
          item={data.filter((item) => item.tipo_cartera === "Total")}
          filtrado={"C"}
          icono={
            <div>
              <ConstructionIcon /> Total
            </div>
          }
          graphics={true}
          permisos={sucursales}
        />
      </tbody>
    </table>
  );
};
